var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        { attrs: { inverted: "" } },
        [
          _c("q-toolbar-title", [
            _vm._v("\n        Geolokalizacja\n        "),
            _c("span", { attrs: { slot: "subtitle" }, slot: "subtitle" }, [
              _vm._v(
                "\n          Kliknij dwukrotnie na mapie by dodać marker. Kliknij dwukrotnie na tytuł markera by zmienić jego opis. Przeciągnij marker by zmienić jego pozycję.\n        "
              )
            ])
          ])
        ],
        1
      ),
      _c("br"),
      _vm.dataLoaded
        ? _c("leaflet-map", {
            attrs: { markers: _vm.dataItems },
            on: {
              "marker-add": _vm.markerAdd,
              "marker-create": _vm.markerCreate,
              "marker-update-position": _vm.markerUpdatePosition,
              "marker-delete": _vm.markerDelete,
              "marker-update-title": _vm.markerUpdateTitle
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }